import React from 'react';
import styled from 'styled-components';
import Button from '@components/shared/Button';
import { EXTERNAL_LINK_SVG } from '@constants';
import { PageSlice } from '@contracts';
import Colors from './Colors';
import LinkTranslated from './LinkTranslated';

interface Props {
  slice: PageSlice;
}

const ButtonRow: React.FC<Props> = ({ slice }) => {
  const backgroundColor = slice.primary?.background_color;
  const textColor = slice.primary?.color;
  const buttons = slice.items ?? [];
  const handleClick = (link: string, scrollToId?: string, newTab: boolean = false) => {
    if (scrollToId?.length > 0) {
      const section = document.querySelector(`#${scrollToId}`);
      section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.open(link, newTab ? '_blank' : '_self');
    }
  };
  return (
    <Container $backgroundColor={backgroundColor} $textColor={textColor}>
      {buttons.map((button, index) => {
        const newTab = button.new_window;
        if (!button.button_text.text) return null;
        if (button.button_style === 'link_with_icon') {
          return (
            <IconLink key={index}>
              <LinkTranslated to={button.button_link?.text} targetBlank={!!newTab}>
                {button.button_text.text}
              </LinkTranslated>
            </IconLink>
          );
        }
        if (button.button_style === 'standard') {
          return (
            <ButtonStyled key={index} onClick={() => handleClick(button.button_link?.text, button.scroll_id?.text, newTab)}>
              {button.button_text.text}
            </ButtonStyled>
          );
        }
        if (button.button_style === 'alt') {
          return (
            <LinkText key={index} onClick={() => handleClick(button.button_link?.text, button.scroll_id?.text, newTab)} $textColor={textColor}>
              {button.button_text.text}
            </LinkText>
          );
        }
      })}
    </Container>
  );
};

export default ButtonRow;

interface StyleProps {
  $backgroundColor?: string;
  $textColor?: string;
}

const Container = styled.div<StyleProps>`
  display: flex;
  width: 100%;
  color: ${(props) => props.$textColor};
  background: ${(props) => props.$backgroundColor};
  flex-direction: row;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }
`;

const ButtonStyled = styled(Button)`
  align-self: center;
  margin: 10px;
`;

const LinkText = styled.button<StyleProps>`
  all: unset;
  cursor: pointer;
  font-family: BrownStd;
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  border-bottom: 2px solid ${(props) => props.$textColor};
`;

const IconLink = styled.div`
  font-family: BrownStd;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;

  a {
    color: ${Colors.lilac};

    :hover {
      text-decoration: underline;
    }

    &:after {
      content: '';
      background-image: url(${EXTERNAL_LINK_SVG});
      background-repeat: no-repeat;
      background-position: center;
      width: 15px;
      height: 15px;
      display: inline-block;
      margin-left: 5px;
      vertical-align: -2px;
    }
  }
`;
